import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logo from '@/images/logo.png'

const Footer = () => {
  const { t } = useTranslation()

  

  const quickLinks = [
    { name: t('nav.products'), href: '/products' },
    { name: t('nav.talents'), href: '/talents' },
    { name: t('nav.copyright'), href: '/copyright' },
    { name: t('nav.international'), href: '/international' },
    { name: t('nav.activities'), href: '/activities' },
    { name: t('nav.partners'), href: '/partners' },
  ]

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container section-padding">
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Platform Info */}
            <div className="col-span-1 lg:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
              <div className="h-12 w-12  flex items-center justify-center flex-shrink-0">
                <img src={logo} alt='logo' className='h-12 w-12' />
              </div>
                <span className="font-semibold text-lg">
                  {t('home.title')}
                </span>
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                {t('home.subtitle')}
              </p>
              <a
                href="http://gxqmyd.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                广西全民阅读网
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-semibold mb-3 text-sm">{t('footer.quickLinks')}</h3>
              <ul className="grid grid-cols-2 gap-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-gray-300 hover:text-white transition-colors text-xs"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="font-semibold mb-3 text-sm">{t('footer.contact')}</h3>
              <div className="space-y-1 text-xs text-gray-300">
                <p>{t('footer.address')}</p>
                <p>{t('footer.phone')}: (+86) 0771-58782796</p>
                <p>{t('footer.postalCode')}: 530023</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2026 {t('home.title')}. {t('footer.copyright')}. 桂ICP备05000446号
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                {t('footer.privacyPolicy')}
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-white text-sm transition-colors"
              >
                {t('footer.termsOfService')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer